'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Functions$BsBastet = require("bs-bastet/bastet/src/Functions.bs.js");

function MonadExtensions(M) {
  var BsMonadExtensions = Functions$BsBastet.Monad(M);
  var flatMap = function (f, ma) {
    return Curry._2(M.flat_map, ma, f);
  };
  var flatten = function (mma) {
    return Curry._2(M.flat_map, mma, (function (v) {
                  return v;
                }));
  };
  return {
          BsMonadExtensions: BsMonadExtensions,
          flatMap: flatMap,
          flatten: flatten,
          composeKleisli: BsMonadExtensions.compose_kliesli,
          flipComposeKleisli: BsMonadExtensions.compose_kliesli_flipped,
          liftM1: BsMonadExtensions.liftM1,
          when_: BsMonadExtensions.when_,
          unless: BsMonadExtensions.unless
        };
}

function MonadInfix(M) {
  var BsMonadExtensions = Functions$BsBastet.Monad(M);
  var flatMap = function (f, ma) {
    return Curry._2(M.flat_map, ma, f);
  };
  var flatten = function (mma) {
    return Curry._2(M.flat_map, mma, (function (v) {
                  return v;
                }));
  };
  var composeKleisli = BsMonadExtensions.compose_kliesli;
  var flipComposeKleisli = BsMonadExtensions.compose_kliesli_flipped;
  var MonadExtensions_liftM1 = BsMonadExtensions.liftM1;
  var MonadExtensions_when_ = BsMonadExtensions.when_;
  var MonadExtensions_unless = BsMonadExtensions.unless;
  var MonadExtensions = {
    BsMonadExtensions: BsMonadExtensions,
    flatMap: flatMap,
    flatten: flatten,
    composeKleisli: composeKleisli,
    flipComposeKleisli: flipComposeKleisli,
    liftM1: MonadExtensions_liftM1,
    when_: MonadExtensions_when_,
    unless: MonadExtensions_unless
  };
  return {
          MonadExtensions: MonadExtensions,
          $great$great$eq: M.flat_map,
          $eq$less$less: flatMap,
          $great$eq$great: composeKleisli,
          $less$eq$less: flipComposeKleisli
        };
}

exports.MonadExtensions = MonadExtensions;
exports.MonadInfix = MonadInfix;
/* Functions-BsBastet Not a pure module */
